import React, { Component } from 'react';
import '../myutils';
import {
  SimpleForm,
  translate,
} from 'react-admin';
import BookIcon from '@material-ui/icons/Book';
import Button from '@material-ui/core/Button';
import FileUpload from '@material-ui/icons/CloudUpload';
import ContentPaste from '@material-ui/icons/ContentPaste';
import FileUploader from '@material-ui/icons/FileUpload';
import {Dialog, DialogContent, DialogTitle, FormControl, FormLabel, RadioGroup, Radio, FormControlLabel, Paper, Typography, Checkbox} from '@material-ui/core';
import {TextField, Table, TableCell, TableBody, TableHead, TableRow} from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import { configAPI } from '../config'
import DropzoneComponent from 'react-dropzone';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import { refreshView as refreshViewAction } from 'ra-core';
import { connect } from 'react-redux';

import * as XLSX from 'xlsx';

export const TemplateIcon = BookIcon;

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  menu: {
    width: 200,
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  }
});

class ListUploader extends Component {

  state = {
    open: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      method: false,
      updateType: false,
      nameCols: 0,
      delimiter: 'TAB',
      prefix: '',
      blocked: 0,
      nameValue: 1,
      phonelist: '',
      response: {}
    }
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    const {refreshView} = this.props;

    this.setState({ open: false, method: false, updateType: false, nameCols: 0, response: {}});
    refreshView();


  };

  onDrop = (files) => {
    this.setState({ selectedFile: files[files.length - 1] })
    var file = files[files.length - 1],
    read = new FileReader();
    read.readAsBinaryString(file);
    read.onload = function () {
      const bstr = read.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      /* Update state */
      this.setState({phonelist: data})
    }.bind(this);

  };

  handleSendSubmit = () => {
    var data = new FormData();
    data.append("data", this.state.phonelist);
    data.append("updateType", this.state.updateType);
    data.append("blocked", this.state.blocked);
    data.append("nameColumns", this.state.nameCols);
    if (this.state.method === 'fileupload') data.append("delimiter", ','); 
    else data.append("delimiter", this.state.delimiter);
    data.append("defaultPrefix", this.state.prefix);
    return fetch(configAPI.api.prod+'UploadPhoneList?token=' + sessionStorage.B.encodeDecode() + '&templateId=' + sessionStorage.templateId, {
        method: "POST",
        body: data
    })
      .then(resp => { return resp.json(); })
      .then(responseGet => {
        if (responseGet.responseStatus === 'OK') {
          this.setState({response: responseGet});
        }
        else {
          this.setState({response: {'message': 404}});
        }
      });
  }

  handleContentChange = (e) => {
    this.setState({ phonelist: e.target.value });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleRadioChange = event => {
    this.setState({ radioValue: event.target.value });
  };


  render() {
    const { translate, classes } = this.props;

    return (
      <Tooltip title={translate(`resources.templates.uploader` + this.props.msg)}>
        <IconButton onClick={this.handleClickOpen}>
          <FileUpload color="primary"  />
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            maxWidth={'md'}
          >
            <IconButton color="inherit" onClick={(e) => this.handleClose(e)} aria-label="Close" style={{ float: 'right' }}>
              <CloseIcon />
            </IconButton>
            <DialogTitle>{translate('resources.templates.uploadTitle')}</DialogTitle>
          <DialogContent>
            {(this.state.response.message === 'ok') ?
              (<>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>{translate(`resources.templates.uploaderTable.totalParsed`)}</TableCell>
                      <TableCell>{translate(`resources.templates.uploaderTable.totalInserted`)}</TableCell>
                      <TableCell>{translate(`resources.templates.uploaderTable.totalUpdated`)}</TableCell>
                      <TableCell>{translate(`resources.templates.uploaderTable.totalRemoved`)}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                        <TableRow>
                          <TableCell>{this.state.response['totalParsed']}</TableCell>
                          <TableCell>{this.state.response['totalInserted']}</TableCell>
                          <TableCell>{this.state.response['totalUpdated']}</TableCell>
                          <TableCell>{this.state.response['totalRemoved']}</TableCell>
                        </TableRow>
                  </TableBody>
                </Table>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>{translate(`resources.templates.uploaderTable.phone`)}</TableCell>
                      <TableCell>{translate(`resources.templates.uploaderTable.name`)}</TableCell>
                      <TableCell>{translate(`resources.templates.uploaderTable.moreinfo`)}</TableCell>
                      <TableCell>{translate(`resources.templates.uploaderTable.blocked`)}</TableCell>
                      <TableCell>{translate(`resources.templates.uploaderTable.errorState`)}</TableCell>
                      <TableCell>{translate(`resources.templates.uploaderTable.originalRowNumber`)}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.response.rejectedRecords.map(row => {
                      return (
                        <TableRow >
                          <TableCell>{row.phone}</TableCell>
                          <TableCell>{row.name}</TableCell>
                          <TableCell>{row.moreinfo}</TableCell>
                          <TableCell><Checkbox checked={row.blocked}/></TableCell>
                          <TableCell>{row.errorState}</TableCell>
                          <TableCell>{row.originalRowNumber}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </>):
              (this.state.response.message === 'bad_format' || this.state.response.message === 404) ? 
              (<>{this.state.response.message}</>): 
              (this.state.updateType === false)?
              (<FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">{translate(`resources.templates.update`)}</FormLabel>
                <RadioGroup
                  aria-label="updateType"
                  name="updateType"
                  value={this.state.radioValue}
                  onChange={this.handleRadioChange}
                  className={classes.group}
                >
                  <FormControlLabel value="UPDATE1" control={<Radio />} label={translate('resources.templates.updateActive')} />
                  <FormControlLabel value="UPDATE2" control={<Radio />} label={translate('resources.templates.updateUnactive')} />
                  <FormControlLabel value="NEW1" control={<Radio />} label={translate('resources.templates.updatereplaceActive')} />
                  <FormControlLabel value="NEW2" control={<Radio />} label={translate('resources.templates.updatereplaceUnactive')} />
                  <FormControlLabel value="REMOVE" control={<Radio />} label={translate('resources.templates.updatefilter')} />
                </RadioGroup>
                <Button onClick={(e) => {
                  switch (this.state.radioValue) {
                    case 'UPDATE1':
                      this.setState({ updateType: 'UPDATE', blocked: 0});
                      break;
                    case 'UPDATE2':
                      this.setState({ updateType: 'UPDATE', blocked: 1});
                      break;
                    case 'NEW1':
                      this.setState({ updateType: 'NEW', blocked: 0});
                      break;
                    case 'NEW2':
                      this.setState({ updateType: 'NEW', blocked: 1});
                      break;
                    default:
                      this.setState({ updateType: this.state.radioValue});
                  }
                  }}
                  color="primary">
                  {translate('ra.action.ok')}
                </Button>
              </FormControl>) :
                (!this.state.method) ?
                  (
                  <Typography variant="headline" >
                  {translate('resources.templates.fileorcontent')}
                  <div>
                  <Button
                    onClick={() => { this.setState({ method: 'fileupload' }) }}
                  >{translate('resources.templates.fileupload')}
                    <FileUploader />
                  </Button>
                    <Button
                      onClick={() => { this.setState({ method: 'contentpaste' }) }}
                    >{translate('resources.templates.contentpaste')}
                      <ContentPaste />
                   </Button>
                   </div>
                  </Typography>  
                  ) :
                  ((this.state.nameCols === 0)&&(this.state.method === 'fileupload')) ? (
                    <FormControl className={classes.container}>
                      <TextField
                        className={classes.textField}
                        type="number"
                        defaultValue='1'
                        value={this.state.nameValue}
                        onChange={this.handleChange('nameValue')}
                        InputProps={{
                          inputProps: {
                            min: 0
                          }
                        }}
                        label={translate('resources.templates.numcols')} />
                      <Button onClick={(e) => this.setState({ nameCols: this.state.nameValue })} color="primary">
                        {translate('ra.action.ok')}
                      </Button>
                    </FormControl>
                  ) :
                  (this.state.method === 'fileupload') ?
                    (
                      <SimpleForm
                        toolbar={false}
                        defaultValue={{ average_note: 0 }}
                      >
                        <div style={{ width: '50%' }}>
                          <DropzoneComponent onDrop={this.onDrop} />
                        </div>
                        <DialogActions>
                          <Button onClick={(e) => this.handleSendSubmit(e)} color="primary">
                            {translate('ra.action.ok')}
                          </Button>
                        </DialogActions>
                      </SimpleForm>
                    ) :
                    (
                      <SimpleForm
                        toolbar={false}
                        defaultValue={{ average_note: 0 }}
                      >
                        <div style={{ width: '100%' }}>
                          <p>{translate('resources.templates.pastecontent1')}</p>
                          <p>{translate('resources.templates.pastecontent2')}</p>
                          <Paper>
                            <TextField
                              id="delimiter"
                              label={translate('resources.templates.delimiter')}
                              helperText={translate('resources.templates.delimiterHT')}
                              className={classes.textField}
                              defaultValue=","
                              value={this.state.delimiter}
                              onChange={this.handleChange('delimiter')}
                              margin="normal"
                            />
                            <TextField
                              id="Prefix"
                              label={translate('resources.templates.prefix')}
                              helperText={translate('resources.templates.prefixHT')}
                              className={classes.textField}
                              defaultValue={translate('resources.templates.noprefix')}
                              value={this.state.prefix}
                              onChange={this.handleChange('prefix')}
                              margin="normal"
                            />
                            <TextField
                              id="outlined-multiline-flexible"
                              multiline
                              fullWidth="false"
                              fullHeigt="true"
                              rows="20"
                              value={this.state.phonelist}
                              onChange={this.handleContentChange}
                              margin="dense"
                              helperText=""
                              variant="outlined"
                            />
                          </Paper>
                        </div>
                        <DialogActions>
                          <Button onClick={(e) => this.handleSendSubmit(e)} color="primary">
                            {translate('ra.action.ok')}
                          </Button>
                        </DialogActions>
                      </SimpleForm>
                    )}
            <br></br>
            </DialogContent>
          </Dialog>
        </IconButton>
      </Tooltip>
    );
  }
}

const enhance = connect(
  null,
  { refreshView: refreshViewAction }
);

export default enhance(withStyles(styles)(translate(ListUploader)));
